import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from "react-localize-redux";
import FaQuestionCircle from "react-icons/lib/fa/question-circle";
import PropTypes from 'prop-types';

import * as actions from '../../actions';

/**
* Import components
*/
import PrevNext from '../PrevNext';
import FormInput from '../forms/FormInput';
import MixForm from '../forms/MixForm';
import ImageContainer from '../image-handler/ImageContainer';
import ZargenSchurzenCode from '../ZargenSchurzenCode';

/**
* class StepOne
*/
class StepFour extends Component {

    /**
    * render method
    * @returns {XML}
    */
    render() {
        const switchButton = {
            position:      "top",
            labelPosition: "right",
            labelName:     "Hinten",
        };

        return (
            <div className="row step-content">
                <div className="row col s12">
                    <h5 className='col s12' >
                        {this.props.translate('DWDF.stepFour.menu.title')}
                    </h5>
                        <div className="col s12 right-align">
                            <FaQuestionCircle style={{fontSize: "20px"}}/>
                            </div>
                            </div>
                            <div className='row'>
                                <div className="col m8 xl6 offset-m2 offset-xl3">
                                    <MixForm
                                        divClass="col m4"
                                        position = "top"
                                        switchBtnClass="row col s12 center-align"
                                        switchButton = {
                                        {
                                        position:      "top",
                                        labelPosition: "right",
                                        labelName:     this.props.translate('DWDF.stepFour.form.back'),
                                        }
                                        }
                                        articleID={this.props.articleID}
                                        switchName={'DWDF.S23_switch'}
                                        switchValue={this.props.dwdf.S23_switch.CurrentValue}
                                        switchChecked={this.props.dwdf.S23_switch.CurrentValue}
                                        checkboxId='1'
                                        checkboxName='DWDF.S23_activator'
                                        checkboxValue={this.props.dwdf.S23_activator.CurrentValue}
                                        checkboxLabelName={this.props.translate('DWDF.stepFour.form.checkbox')}
                                        checkboxDivClass='col m6'
                                        checkboxChecked = {this.props.dwdf.S23_activator.CurrentValue === '1'}
                                        checkboxDisabled={this.props.dwdf.S23_switch.CurrentValue !== 1}
                                        radioName='DWDF.S23'
                                        radioCheckboxClass="col m4 center-align"
                                        radioCheckboxPosition= ""
                                        radioValue1='02'
                                        radioChecked1={this.props.dwdf.S23.CurrentValue}
                                        radioDisabled1={this.props.dwdf.S23_activator.CurrentValue !== '1'}
                                        radioValue2='03'
                                        radioChecked2={this.props.dwdf.S23.CurrentValue}
                                        radioDisabled2={this.props.dwdf.S23_activator.CurrentValue !== '1'}
                                        inputName1={'DWDF.SM23'}
                                        inputValue1={this.props.dwdf.S23.CurrentValue === '02' ? this.props.dwdf.SM23.CurrentValue : ''}
                                        inputName2={'DWDF.SM23'}
                                        inputValue2={this.props.dwdf.S23.CurrentValue === '03' ? this.props.dwdf.SM23.CurrentValue : ''}
                                        inputMin1={0}
                                        inputMax1={this.props.dwdf.W_LAENGE.CurrentValue}
                                        inputStep1={0.1}
                                        inputMin2={0}
                                        inputMax2={this.props.dwdf.W_LAENGE.CurrentValue}
                                        inputStep2={0.1}
                                    />
                                    </div>


                                    </div>
                                    <div className="col m4 xl3 valign-wrapper">
                                        <MixForm
                                            divClass="col m9 xl8"
                                            position = "left"
                                            switchBtnClass="row col m9 xl10 offset-m3 offset-xl2 center-align"
                                            switchButton = {
                                            {
                                            position:      "top",
                                            labelPosition: "left",
                                            labelName:     this.props.translate('DWDF.stepFour.form.left'),
                                            }
                                            }
                                            articleID={this.props.articleID}
                                            switchName={'DWDF.S81_switch'}
                                            switchValue={this.props.dwdf.S81_switch.CurrentValue}
                                            checkboxId='1'
                                            checkboxName='DWDF.S81_activator'
                                            checkboxValue={this.props.dwdf.S81_activator.CurrentValue}
                                            checkboxLabelName={this.props.translate('DWDF.stepFour.form.checkbox')}
                                            checkboxChecked = {this.props.dwdf.S81_activator.CurrentValue === '1'}
                                            checkboxDisabled={this.props.dwdf.S81_switch.CurrentValue !== 1}
                                            radioName='DWDF.S81'
                                            radioCheckboxClass="col m9 xl8"
                                            radioCheckboxPosition= "left"
                                            radioValue1='01'
                                            radioChecked1={this.props.dwdf.S81.CurrentValue}
                                            radioDisabled1={this.props.dwdf.S81_activator.CurrentValue !== '1'}
                                            radioValue2='08'
                                            radioChecked2={this.props.dwdf.S81.CurrentValue}
                                            radioDisabled2={this.props.dwdf.S81_activator.CurrentValue !== '1'}
                                            inputName1={'DWDF.SM81'}
                                            inputValue1={this.props.dwdf.S81.CurrentValue === '01' ? this.props.dwdf.SM81.CurrentValue : ''}
                                            inputName2={'DWDF.SM81'}
                                            inputValue2={this.props.dwdf.S81.CurrentValue === '08' ? this.props.dwdf.SM81.CurrentValue : ''}
                                            inputMin1={0}
                                            inputMax1={this.props.dwdf.W_BREITE.CurrentValue}
                                            inputStep1={0.1}
                                            inputMin2={0}
                                            inputMax2={this.props.dwdf.W_BREITE.CurrentValue}
                                            inputStep2={0.1}
                                        />

                                        </div>
                                        <div className="row col s4 xl6">
                                            <ImageContainer
                                                image={this.props.image.Image}
                                                name="dwdf"
                                                divClass="col s12"
                                                height="100%" />
                                                </div>
                                                <div className="col m4 xl3 valign-wrapper">
                                                    <MixForm
                                                        divClass="col m9 xl8 offset-xl4 offset-m3"
                                                        position = "right"
                                                        switchBtnClass="row col m9 xl8 offset-m3 offset-xl4"
                                                        switchButton = {{
                                                        position:      "top",
                                                        labelPosition: "right",
                                                        labelName:     this.props.translate('DWDF.stepFour.form.right'),
                                                        }}
                                                        articleID={this.props.articleID}
                                                        switchName={'DWDF.S45_switch'}
                                                        switchValue={this.props.dwdf.S45_switch.CurrentValue}
                                                        switchDisabled={!this.props.dwdf.S45.CurrentValue === '0'}
                                                        checkboxLabelName={this.props.translate('DWDF.stepFour.form.checkbox')}
                                                        checkboxId='3'
                                                        checkboxName='DWDF.S45_activator'
                                                        checkboxValue={this.props.dwdf.S45_activator.CurrentValue}
                                                        checkboxChecked = {this.props.dwdf.S45_activator.CurrentValue === '1'}
                                                        checkboxDisabled={this.props.dwdf.S45_switch.CurrentValue !== 1}
                                                        radioName='DWDF.S45'
                                                        radioCheckboxClass="col m9 xl8 offset-m3 offset-xl4"
                                                        radioCheckboxPosition= "right"
                                                        radioValue1='04'
                                                        radioChecked1={this.props.dwdf.S45.CurrentValue}
                                                        radioDisabled1={this.props.dwdf.S45_activator.CurrentValue !== '1'}
                                                        radioValue2='05'
                                                        radioChecked2={this.props.dwdf.S45.CurrentValue}
                                                        radioDisabled2={this.props.dwdf.S45_activator.CurrentValue !== '1'}
                                                        inputName1={'DWDF.SM45'}
                                                        inputValue1={this.props.dwdf.S45.CurrentValue === '04' ? this.props.dwdf.SM45.CurrentValue : ''}
                                                        inputName2={'DWDF.SM45'}
                                                        inputValue2={this.props.dwdf.S45.CurrentValue === '05' ? this.props.dwdf.SM45.CurrentValue : ''}
                                                        inputMin1={0}
                                                        inputMax1={this.props.dwdf.W_BREITE.CurrentValue}
                                                        inputStep1={0.5}
                                                        inputMin2={0}
                                                        inputMax2={this.props.dwdf.W_BREITE.CurrentValue}
                                                        inputStep2={0.5}
                                                    />
                                                    </div>
                                                    <div className="row col m8 xl6 offset-m2 offset-xl3">
                                                        <MixForm
                                                            divClass="col s4"
                                                            position = "right"
                                                            switchBtnClass="row col s12 center-align"
                                                            switchButton = {
                                                            {
                                                            position:      "top",
                                                            labelPosition: "right",
                                                            labelName:     this.props.translate('DWDF.stepFour.form.front'),
                                                            }
                                                            }
                                                            articleID={this.props.articleID}
                                                            switchName={'DWDF.S67_switch'}
                                                            switchValue={this.props.dwdf.S67_switch.CurrentValue}
                                                            switchDisabled={!this.props.dwdf.S67.CurrentValue === '0'}
                                                            checkboxId='1'
                                                            checkboxName='DWDF.S67_activator'
                                                            checkboxValue={this.props.dwdf.S67_activator.CurrentValue}
                                                            checkboxLabelName={this.props.translate('DWDF.stepFour.form.checkbox')}
                                                            checkboxDivClass='col m6'
                                                            checkboxChecked = {this.props.dwdf.S67_activator.CurrentValue === '1'}
                                                            checkboxDisabled={this.props.dwdf.S67_switch.CurrentValue !== 1}
                                                            radioName='DWDF.S67'
                                                            radioCheckboxClass="col s4 center-align"
                                                            radioCheckboxPosition= ""
                                                            radioValue1='07'
                                                            radioChecked1={this.props.dwdf.S67.CurrentValue}
                                                            radioDisabled1={this.props.dwdf.S67_activator.CurrentValue !== '1'}
                                                            radioValue2='06'
                                                            radioChecked2={this.props.dwdf.S67.CurrentValue}
                                                            radioDisabled2={this.props.dwdf.S67_activator.CurrentValue !== '1'}
                                                            inputName1={'DWDF.SM67'}
                                                            inputValue1={this.props.dwdf.S67.CurrentValue === '07' ? this.props.dwdf.SM67.CurrentValue : ''}
                                                            inputName2={'DWDF.SM67'}
                                                            inputValue2={this.props.dwdf.S67.CurrentValue === '06' ? this.props.dwdf.SM67.CurrentValue : ''}
                                                            inputMin1={0}
                                                            inputMax1={this.props.dwdf.W_LAENGE.CurrentValue}
                                                            inputStep1={0.1}
                                                            inputMin2={0}
                                                            inputMax2={this.props.dwdf.W_LAENGE.CurrentValue}
                                                            inputStep2={0.1}
                                                        />
                                                        </div>

                                                        <div className="row col s12">
                                                            <ZargenSchurzenCode
                                                                articleID={this.props.articleID}
                                                                article='dwdf'
                                                                fieldCode='SZ'
                                                                inputName="DWDF.SZ"
                                                                inputValue={this.props.dwdf.SZ.CurrentValue}
                                                                labelName={this.props.translate('DWDF.stepFour.form.title')}
                                                                className="custom-input-number__button--schurzen"
                                                            />
                                                            <FormInput
                                                                type='number'
                                                                name="DWDF.SH"
                                                                disabled={this.props.dwdf.S23_switch.CurrentValue !== 1 && this.props.dwdf.S45_switch.CurrentValue !== 1 && this.props.dwdf.S67_switch.CurrentValue !== 1 && this.props.dwdf.S81_switch.CurrentValue !== 1}
                                                                value={this.props.dwdf.SH.CurrentValue}
                                                                labelPosition='inline'
                                                                label={this.props.translate('DWDF.stepFour.form.sheight')}
                                                                labelStyle={{paddingRight: '10px', fontSize: "14px", color: "#003B71"}}
                                                                id='custom-input-number'
                                                                step={0.5}
                                                                min={4}
                                                                max={25}
                                                                subLabel="(4 - 25)"
                                                                subLabelStyle={{paddingLeft: '15px'}}
                                                                divClass="col s6 m6" />
                                                        </div>
                                                        </div>
        )
    }

}
StepFour.propTypes = {
    lastStep:   PropTypes.number,
    translate:  PropTypes.func,
    dwdf:       PropTypes.object,
    isFormValid:     PropTypes.func.isRequired,
}

function mapStateToProps({locale, dwdf, image}) {
    return {
        translate: getTranslate(locale),
        dwdf,
        image,
    }
}

export default connect(mapStateToProps, actions)(StepFour);




// WEBPACK FOOTER //
// ./src/components/dwdf-steps/StepFour.js